

import { useEffect, useState } from 'react';
import * as Yup from 'yup'
import { SpinContainer } from '../../../StyledComponents/Queries';
import { DetailContainer, FormikForm, FormItem } from '../../../StyledComponents/CreateKeyAccountManager';
import { useDispatch, useSelector } from 'react-redux';

import { ErrorMessage } from 'formik';
import { Button, DatePicker, Select, Spin } from 'antd';
import styled from 'styled-components';
import { BottomContent, DetailRow, LeftContent, RowValue, TitleDiv, TitleRow } from '../../../StyledComponents/Markup';
import { createOdccMarkup, getOdccStrategiesList, updateOdccMarkup } from '../../../store/Markup/markupSlice';
import { updatenotificationdata } from '../../../store/Common/CommonSlice';
import dayjs from 'dayjs';

import SimpleInput from '../Common/SimpleInput';
import SelectMultipleWithSearch from './SelectMultipleWithSearch';


const validationSchema = Yup.object().shape({
    origin: Yup.array()
        .of(Yup.string())
        .min(1, 'At least one origin is required')
        .test('unique-origin', 'Origin and destination cannot be the same', function (value) {
            return !(value.some(v =>v!="all"&& this.parent.destination?.includes(v)));
        })
        .test('all-selection', 'Cannot select other values when "All" is selected', function (value) {
            return !(value.includes('all') && value.length > 1);
        }),

    destination: Yup.array()
        .of(Yup.string())
        .min(1, 'At least one destination is required')
        .test('unique-destination', 'Destination and origin cannot be the same', function (value) {
            return !(value.some(v =>v!="all"&&this.parent.origin?.includes(v)));
        })
        .test('all-selection', 'Cannot select other values when "All" is selected', function (value) {
            return !(value.includes('all') && value.length > 1);
        }),

    carrier: Yup.array()
        .of(Yup.string())
        .min(1, 'At least one carrier is required')
        .test('all-selection', 'Cannot select other values when "All" is selected', function (value) {
            return !(value.includes('All') && value.length > 1);
        }),

    commodity: Yup.array()
        .of(Yup.string())
        .min(1, 'At least one commodity is required')
        .test('all-selection', 'Cannot select other values when "All" is selected', function (value) {
            return !(value.includes('All') && value.length > 1);
        }),

    customer_category: Yup.array()
        .of(Yup.string())
        .min(1, 'At least one customer category is required')
        .test('all-selection', 'Cannot select other values when "All" is selected', function (value) {
            return !(value.includes('All') && value.length > 1);
        }),

    markup: Yup.number()
        .required('Markup % is required'),

    active_from: Yup.date().required('Active From date is required'),

    active_till: Yup.date()
        .required('Active Till date is required')
        .min(Yup.ref('active_from'), 'Active Till must be after Active From'),
});
let initialValues = {
    odcc_id: undefined,
    origin: [],
    destination: [],
    carrier: [],
    commodity: [],
    customer_category: [],
    markup: undefined,
    active_from: undefined,
    active_till: undefined,
}
function CreateODCSStrategyForm({ pageType, existedOdcs, setPageType }) {
    const [loading, setLoading] = useState(false);
    const [updatedData, setUpdatingData] = useState(existedOdcs);

    const [type, setType] = useState(pageType || "create");
    const dispatch = useDispatch();

    const { listOfAirport, listOfAirline, customerCategory } = useSelector((state) => state.markup);
    let cusomerCategegryData = customerCategory.map((element) => {
        return {
            _id: element._id,
            name: element.category_name,
            value: element.category_name,
            code: element.category_name
        }
    })
    cusomerCategegryData.push({code:"all",name:"all",value:"all"});
    let listOfAllAirline=listOfAirline.map((element)=>{
        return{
            code:element.code,
            name:element.code,
            value:element.code
        }
    });
    listOfAllAirline.push({code:"all",name:"all",value:"all"})

    if (type == "edit") {
        initialValues = {
            odcc_id: updatedData?.id || undefined,
            origin: updatedData?.origin.split(",")|| [],
            destination: updatedData?.destination.split(",") || [],
            carrier: updatedData?.carrier.split(",") || [],
            commodity: updatedData?.commodity.split(",") || [],
            customer_category: updatedData?.customer_category.split(",") || [],
            markup: updatedData?.markup || undefined,
            active_from: updatedData?.active_from || undefined,
            active_till: updatedData?.active_till || undefined,
        }
    } else {
        initialValues = {
            odcc_id: undefined,
            origin: [],
            destination: [],
            carrier: [],
            commodity: [],
            customer_category: [],
            markup: undefined,
            active_from: undefined,
            active_till: undefined,
        }
    }

    const handleSelectChange = (e, name, setFieldValue) => {
        setFieldValue([name], e);

    }
    const handleDateChange = (key, date, dateString, setFieldValue) => {
        setFieldValue(key, date);

    };
    const charge_basises = [{
        value: "all",
        name: "All",
        code: "all"
    },
    {
        value: "general",
        name: "general",
        code: "general"
    }
    ]


    return < >
        {
            loading ? <SpinContainer className='user-quote'>
                <Spin />
            </SpinContainer> : <FormikForm
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { resetForm, setFieldValue }) => {
                    const mappedData = {
                        odcc_id: values.odcc_id || "",
                        origin: values.origin,
                        destination: values.destination,
                        carrier: values.carrier,
                        commodity: values.commodity || ['all'],
                        activeFrom: values.active_from,
                        activeTill: values.active_till,
                        customer_category: values.customer_category,
                        markup_percentage: values.markup

                    };

                    console.log("mapded", mappedData)
                    setLoading(true)
                    if (mappedData.odcc_id == "") {
                        dispatch(createOdccMarkup(mappedData)).then((res) => {

                            dispatch(updatenotificationdata(res.payload))
                            dispatch(getOdccStrategiesList());

                            if (res.payload.success == "error") {

                            } else {
                                setPageType('table');
                                resetForm();
                            }

                        }).catch((error) => {
                            dispatch(updatenotificationdata(error.payload));
                            console.log("errrrr0", error)

                        }).finally(() => setLoading(false))
                    } else {
                        dispatch(updateOdccMarkup(mappedData)).then((res) => {
                            dispatch(updatenotificationdata(res.payload))
                            dispatch(getOdccStrategiesList());
                            if (res.payload.success == "error") {

                            } else {
                                setPageType('table')
                            }

                        }).catch((error) => {
                            console.log(error, 'updateerror')
                        }).finally(() => setLoading(false))
                    }
                }}
            >
                {({ values, setFieldValue, handleChange, handleBlur, resetForm }) => (
                    <FormItem >
                        <DetailContainer>
                            <BottomContent>
                                <LeftContent>
                                    <DetailRow style={{
                                        flexFlow: "column",
                                        width: "100%"
                                    }}>
                                        <TitleDiv>
                                            <TitleRow>Origin*</TitleRow>
                                        </TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SelectMultipleWithSearch mode={true} name="origin" setFieldValue={setFieldValue} value={values.origin} options={listOfAirport} width="100%" bradius="8px" placeholder="Origin" />

                                            <ErrorMessage name="origin" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>
                                    <DetailRow>
                                        <TitleDiv>
                                            <TitleRow>Destination*</TitleRow>
                                        </TitleDiv>

                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SelectMultipleWithSearch mode={true} name="destination" setFieldValue={setFieldValue} value={values.destination} options={listOfAirport} width="100%" bradius="8px" placeholder="Destinations" />
                                            <ErrorMessage name="destination" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>
                                    <DetailRow>
                                        <TitleDiv>
                                            <TitleRow>Carrier*</TitleRow>
                                        </TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <SelectMultipleWithSearch mode={true} name="carrier" setFieldValue={setFieldValue} value={values.carrier} options={listOfAllAirline} width="100%" bradius="8px" placeholder="Carrier" />
                                            <ErrorMessage name="carrier" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Commodity*</TitleRow></TitleDiv>

                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>

                                            <SelectMultipleWithSearch mode={true} name="commodity" setFieldValue={setFieldValue} value={values.commodity} options={charge_basises} width="100%" bradius="8px" placeholder="Commodity" />

                                            <ErrorMessage name="commodity" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>

                                    </DetailRow>
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Customer Category*</TitleRow></TitleDiv>

                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>

                                            <SelectMultipleWithSearch mode={true} name="customer_category" setFieldValue={setFieldValue} value={values.customer_category} options={cusomerCategegryData} width="100%" bradius="8px" placeholder="Carrier" />

                                            <ErrorMessage name="customer_category" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>

                                    </DetailRow>
                                    <DetailRow>
                                        <TitleDiv><TitleRow>Markup %*</TitleRow></TitleDiv>

                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>

                                            <SimpleInput
                                                id="markup"
                                                name="markup"
                                                type="number"
                                                value={values?.markup}
                                                size="large"
                                                placeholder='Markup'
                                                handleChange={handleChange}
                                            />
                                            <ErrorMessage name="markup" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>

                                    </DetailRow>

                                    <DetailRow>
                                        <TitleDiv> <TitleRow>Active From*</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <DatePicker className="w-full  "
                                                onChange={(date, dateString) => handleDateChange("active_from", date, dateString, setFieldValue)}
                                                value={values.active_from ? dayjs(values.active_from) : null}
                                                placeholder="Active From"
                                                disabledDate={(current) => {
                                                    return current && (current < dayjs().startOf("day") || current > dayjs().add(3, "month").endOf("day"));
                                                }}
                                            />
                                            <ErrorMessage name="active_from" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>
                                    <DetailRow>
                                        <TitleDiv> <TitleRow>Active Till*</TitleRow></TitleDiv>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '80%' }}>
                                            <DatePicker className="w-full  "
                                                onChange={(date, dateString) => handleDateChange("active_till", date, dateString, setFieldValue)}
                                                value={values.active_till ? dayjs(values.active_till) : null}
                                                placeholder="Active Till"
                                                disabledDate={(current) => {
                                                    return current && (current < dayjs().startOf("day") || current > dayjs().add(3, "month").endOf("day"));
                                                }}
                                            />
                                            <ErrorMessage name="active_till" component="div" style={{ color: 'red', fontSize: '12px' }} />
                                        </div>
                                    </DetailRow>
                                </LeftContent>
                            </BottomContent>
                            <Button
                                className="bg-[#679fee] w-fit ml-6 font-normal md:font-medium"
                                type="submit"
                                htmlType="submit"
                                loading={loading}
                            >
                                {type == 'edit' ? "Update" : "Create"}
                            </Button>

                        </DetailContainer>
                    </FormItem>
                )}
            </FormikForm>
        }
    </>
}

export default CreateODCSStrategyForm;
const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: 8px !important;
        padding: ${({ pdg }) => pdg ? pdg : "unset"};
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 16px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #d9d9d9 !important
    }
    /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`